var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 229.3 68.3",
    style: {
      enableBackground: "new 0 0 229.3 68.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B2B2B2;}\r\n\t.st1{fill:#575756;}\r\n\t.st2{fill:#282727;}\r\n\t.st3{fill:#878787;}\r\n\t.st4{fill:#BCCF00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,22.9C12.9,27.2,3.6,38,0.1,50.4l38.1,17.8l15.3-16.4c1-10.8-2.2-21.9-9.6-30.4 C38.5,20.7,32.6,21.1,26.6,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.9,49.3l11.3-12.1l-4.3-7.7c-4.6-3.6-10-6.2-15.9-7.5C53.2,29.8,56.2,39.5,55.9,49.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.3,26.6c0-5.9,3.5-8.8,8.6-8.8s8.6,2.8,8.6,8.8v0.2h-3.8v-0.2c0-3.7-1.9-5.2-4.8-5.2s-4.8,1.5-4.8,5.2 v11.8h-3.9V26.6H80.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.5,12.5c0-1.5,1.1-2.7,2.7-2.7c1.5,0,2.7,1.1,2.7,2.7c0,1.5-1.1,2.7-2.7,2.7 C103.7,15.2,102.5,14,102.5,12.5z M103.3,18.4h3.9v20h-3.9V18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.2,30.8V11.3h3.9v7.1h11v3.5h-11v8.9c0,3.2,1.7,4.5,4.2,4.5s4.2-1.3,4.2-4.5v-0.4h3.8v0.4 c0,5.4-3.2,8.1-8,8.1C117.5,38.9,114.2,36.3,114.2,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.3,35.3l12.9-13.4h-12.3v-3.5h17.4v3.2L140.4,35h13.3v3.4h-18.4L135.3,35.3L135.3,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.6,28.4c0-6.1,4.5-10.5,10.8-10.5s10.7,4.5,10.7,10.5v1.4h-17.4c0.6,3.6,3.2,5.6,6.7,5.6 c2.6,0,4.4-0.8,5.6-2.6h4.3c-1.5,3.7-5.2,6.1-9.9,6.1C163.1,38.9,158.6,34.5,158.6,28.4z M176,26.4c-0.8-3.2-3.4-4.9-6.6-4.9 c-3.3,0-5.8,1.8-6.6,4.9H176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.7,26.6c0-5.9,3.5-8.8,8.6-8.8s8.6,2.8,8.6,8.8v0.2h-3.8v-0.2c0-3.7-1.9-5.2-4.8-5.2 c-2.9,0-4.8,1.5-4.8,5.2v11.8h-3.9L185.7,26.6L185.7,26.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.2,52.2c0-2.8,2-4.8,4.9-4.8s4.9,2,4.9,4.8v4.5h-1.1v-2.3c-0.6,1.6-2.1,2.5-3.9,2.5 C82.3,56.9,80.2,55.1,80.2,52.2z M88.7,52.2c0-2.1-1.5-3.6-3.6-3.6c-2.2,0-3.6,1.5-3.6,3.6s1.5,3.6,3.6,3.6 C87.2,55.8,88.7,54.2,88.7,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.1,52.4v-4.7h1.2v4.7c0,2.2,1.3,3.4,3.2,3.4c2,0,3.2-1.2,3.2-3.4v-4.7h1.2v4.7c0,3-1.8,4.6-4.5,4.6 C93.9,56.9,92.1,55.4,92.1,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.2,53.3v-8.9h1.2v3.2h5.3v1.1h-5.3v4.6c0,1.6,0.9,2.4,2.3,2.4c1.4,0,2.3-0.8,2.3-2.4v-0.2h1.2v0.2 c0,2.4-1.4,3.6-3.5,3.6C104.7,56.9,103.2,55.7,103.2,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.9,52.2c0-2.7,2-4.8,4.9-4.8s4.9,2,4.9,4.8c0,2.7-2,4.8-4.9,4.8S111.9,54.9,111.9,52.2z M120.4,52.2 c0-2.1-1.5-3.6-3.6-3.6s-3.6,1.5-3.6,3.6s1.5,3.6,3.6,3.6S120.4,54.2,120.4,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.4,51.4c0-2.7,1.6-4,3.7-4c1.5,0,2.7,0.7,3.3,2c0.6-1.3,1.8-2,3.3-2c2.1,0,3.7,1.3,3.7,4v5.3h-1.2v-5.3 c0-1.9-1.1-2.9-2.5-2.9c-1.5,0-2.5,1-2.5,2.9v5.3H130v-5.3c0-1.9-1.1-2.9-2.6-2.9s-2.5,0.9-2.5,2.9v5.3h-1.2v-5.3H123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.1,52.2c0-2.8,2-4.8,4.9-4.8s4.9,2,4.9,4.8v4.5h-1.1v-2.3c-0.6,1.6-2.1,2.5-3.9,2.5 C141.3,56.9,139.1,55.1,139.1,52.2z M147.6,52.2c0-2.1-1.5-3.6-3.6-3.6s-3.6,1.5-3.6,3.6s1.5,3.6,3.6,3.6S147.6,54.2,147.6,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.1,53.3v-8.9h1.2v3.2h5.3v1.1h-5.3v4.6c0,1.6,0.9,2.4,2.3,2.4c1.4,0,2.3-0.8,2.3-2.4v-0.2h1.2v0.2 c0,2.4-1.4,3.6-3.5,3.6C152.5,56.9,151.1,55.7,151.1,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.1,44.9c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9C160.5,45.9,160.1,45.5,160.1,44.9z  M160.4,47.6h1.2v9.1h-1.2V47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.9,54.1h1.2c0.1,1,0.9,1.7,2.5,1.7s2.5-0.7,2.5-1.7c0-1.1-1.2-1.2-2.5-1.4c-1.6-0.2-3.5-0.5-3.5-2.5 c0-1.7,1.3-2.9,3.5-2.9c2.1,0,3.4,1.2,3.5,2.7h-1.2c-0.1-0.9-0.9-1.6-2.3-1.6c-1.4,0-2.2,0.7-2.2,1.6c0,1.1,1.2,1.2,2.5,1.4 c1.4,0.2,3.5,0.4,3.5,2.5c0,1.7-1.4,2.9-3.7,2.9C165.3,56.9,163.9,55.7,163.9,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.2,44.9c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9C173.6,45.9,173.2,45.5,173.2,44.9z  M173.5,47.6h1.2v9.1h-1.2V47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.9,52.2c0-2.7,2-4.8,4.9-4.8s4.8,2,4.8,4.8v0.4h-8.4c0.2,1.9,1.6,3.2,3.6,3.2c1.4,0,2.5-0.6,3.1-1.6h1.3 c-0.7,1.7-2.3,2.8-4.5,2.8C178.9,56.9,176.9,54.9,176.9,52.2z M185.3,51.5c-0.3-1.8-1.7-2.9-3.6-2.9c-1.9,0-3.3,1.2-3.6,2.9H185.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.4,51.3c0-2.6,1.6-3.9,3.8-3.9c2.3,0,3.8,1.3,3.8,3.9v0.1h-1.2v-0.1c0-1.9-1-2.7-2.6-2.7 s-2.6,0.8-2.6,2.7v5.4h-1.2V51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.6,52.4v-4.7h1.2v4.7c0,2.2,1.3,3.4,3.2,3.4s3.2-1.2,3.2-3.4v-4.7h1.2v4.7c0,3-1.8,4.6-4.5,4.6 S197.6,55.4,197.6,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208.8,52c0-3,1.8-4.6,4.5-4.6s4.5,1.6,4.5,4.6v4.7h-1.2V52c0-2.2-1.3-3.4-3.2-3.4s-3.2,1.2-3.2,3.4v4.7H209 V52H208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.9,57.9h1.2c0.5,1.3,1.8,1.8,3.3,1.8c2.1,0,3.6-1,3.6-3.7v-1.3c-0.7,1.4-2.1,2.2-3.8,2.2 c-2.5,0-4.7-1.8-4.7-4.7c0-2.7,2-4.8,4.9-4.8s4.9,1.9,4.9,4.8v3.7c0,3.5-2.1,4.9-4.8,4.9C222.3,60.8,220.5,59.9,219.9,57.9z  M228,52.2c0-2.1-1.5-3.6-3.6-3.6s-3.6,1.5-3.6,3.6s1.5,3.6,3.6,3.6S228,54.2,228,52.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.9,8.6L0,48.2c5.1-16.8,20.5-30.3,41-29.8c-3.7-3.4-8.2-6.2-13.4-8.2C20,7.3,12.1,7,4.9,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.2,16.9c0.6,0.5,1.2,1.1,1.8,1.6c5.6,0.5,10.9,2.2,15.6,4.8L46.7,0L13.2,6.5C23.1,6.1,33.4,9.2,42.2,16.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a0ab4c7e25cade4e3fbcc6479ce80df.svg";
export { ForwardRef as ReactComponent };